import * as React from "react"
import Svg, { Rect, Path } from "react-native-svg"

const IconeIvehteMissions = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={57} height={57} fill="none" viewBox="0 0 57 57" {...props}>
            <Rect width={57} height={57} fill="#fff" rx={10} />
            <Path
                fill="#4BBAED"
                d="M19.75 19.746h-4.746v-2.373A2.376 2.376 0 0117.377 15a2.376 2.376 0 012.373 2.373v2.373z"
            />
            <Path fill="#388CB3" d="M19.75 19.746v-2.373A2.376 2.376 0 0017.377 15v4.746h2.373z" />
            <Path fill="#4BBAED" d="M19.75 42h-4.746V29.238h4.746V42z" />
            <Path fill="#388CB3" d="M17.377 29.238h2.373V42h-2.373V29.238z" />
            <Path
                fill="#FFE565"
                d="M35.215 32.451a9.627 9.627 0 01-5.322-1.6 8.005 8.005 0 00-6.709-1.011l-3.32.98h-1.696V18.166h1.466l3.1-.925a9.584 9.584 0 018.034 1.21 8.05 8.05 0 007.214.844l.658-.243 3.357 6.545-3.179 6.159-.288.106a9.582 9.582 0 01-3.315.59z"
            />
            <Path
                fill="#FFD400"
                d="M37.982 19.293a8.05 8.05 0 01-7.214-.844 9.625 9.625 0 00-2.265-1.107v12.77c.482.199.947.445 1.39.739a9.628 9.628 0 008.637 1.01l.288-.107 3.179-6.158-3.357-6.546-.658.243z"
            />
            <Path fill="#FFAB2D" d="M19.75 30.82h-4.746V18.164h4.746V30.82z" />
            <Path fill="#F90" d="M17.377 18.164h2.373V30.82h-2.373V18.164z" />
        </Svg>
    )
}

export default IconeIvehteMissions
